import { DarwinButton, DarwinFlex } from 'components/darwin-ui';
import { useTranslation } from 'react-i18next';

export interface ButtonsSaveCancelProps {
  showButtons?: boolean;
  onSave?: () => void;
  onCancel?: () => void;
  onSaveTitle?: string;
  saveDisabled?: boolean;
  displayExtraButton?: boolean;
  extraButtonTitle?: string;
  onExtraButtonClick?: () => void;
  extraButtonDisabled?: boolean;
}

export const ButtonsSaveCancel = ({
  showButtons = true,
  onSave,
  onCancel,
  onSaveTitle,
  saveDisabled,
  displayExtraButton = false,
  onExtraButtonClick,
  extraButtonTitle = '',
  extraButtonDisabled = false,
}: ButtonsSaveCancelProps) => {
  const { t } = useTranslation();
  return (
    <DarwinFlex gap={12} align="center">
      {showButtons && onCancel && (
        <DarwinButton onClick={onCancel}>{t('cancel')}</DarwinButton>
      )}
      {showButtons && onSave && (
        <DarwinButton type="primary" onClick={onSave} disabled={saveDisabled}>
          {t(onSaveTitle || 'save')}
        </DarwinButton>
      )}
      {showButtons &&
        extraButtonTitle &&
        displayExtraButton &&
        onExtraButtonClick && (
          <DarwinButton
            type="primary"
            onClick={onExtraButtonClick}
            disabled={extraButtonDisabled}
          >
            {extraButtonTitle}
          </DarwinButton>
        )}
    </DarwinFlex>
  );
};
